import React from 'react'

const ActionsSkeleton = () => {
    return (
        <div className="action-widget-card bg-white rounded-[10px] w-full h-full p-[35px] animate-pulse">
            {/* Title section */}
            <div className="h-6 bg-lightBG rounded w-[40%] mb-[5px] opacity-50"></div>
            <div className="h-4 bg-lightBG rounded w-[60%] mb-[20px] opacity-50"></div>

            {/* Main content section */}
            <div className="flex w-full gap-4 h-[162px]">
                {/* Left colored block - emotions section */}
                <div className="rounded-[10px] h-full w-[190px] flex flex-col justify-between p-[20px] bg-lightMint opacity-50">
                    <div className="flex flex-row justify-around items-start">
                        <div className="rounded-full bg-containerGray w-[40px] h-[40px] flex items-center justify-center mr-[10px]"></div>
                        <div className="bg-white h-4 rounded w-[60%] opacity-70"></div>
                    </div>

                    {/* Emotion icons placeholder */}
                    <div className="rounded-[10px] flex flex-col justify-center items-center">
                        <div className="flex flex-row justify-center items-center gap-2">
                            {[...Array(4)].map((_, index) => (
                                <div key={index} className="w-[30px] h-[30px] bg-white rounded-full opacity-70 mx-1"></div>
                            ))}
                        </div>
                        <div className="flex flex-row justify-center items-center gap-2 mt-2">
                            {[...Array(3)].map((_, index) => (
                                <div key={index} className="w-[30px] h-[30px] bg-white rounded-full opacity-70 mx-1"></div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Right buttons section */}
                <div className="w-[52%] flex flex-col gap-[14px] h-full">
                    {/* Actions assigned to me button */}
                    <div className="flex flex-row justify-between items-center bg-containerGray rounded-xl pr-[25px] pl-[17px] py-[17px] h-[50%]">
                        <div className="bg-lightBG h-5 rounded w-[60%] opacity-50"></div>
                        <div className="bg-lightMint w-[35px] h-[35px] rounded-full opacity-50 flex items-center justify-center"></div>
                    </div>

                    {/* Student chat button */}
                    <div className="flex flex-row justify-between items-center bg-containerGray rounded-xl pr-[25px] pl-[17px] py-[17px] h-[50%]">
                        <div className="bg-lightBG h-5 rounded w-[40%] opacity-50"></div>
                        <div className="bg-lightMint w-[35px] h-[35px] rounded-full opacity-50 flex items-center justify-center"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActionsSkeleton
